/**
 * All known feature flags returned by the getFeatureFlags GraphQL query.
 * When adding a new flag, add it here.
 */
export type FeaturesFlagsData = {
  advancedAiPackage: boolean;
  dashboardExtensionEnableRestrictedCompaniesAssetsPage: boolean;
  disableFrontendTracking: boolean;
  conversationIntelligenceCustomerProvisioning: boolean;
  conversationCenterDisableSentiments: boolean;
  dashboardExtensionEnableConversationsCenterCsat: boolean;
  playbookAdherence: boolean;
};

/**
 * GraphQL flag names (snake_case) requested from `getFeatureFlags`. Keep in sync
 * with the camelCase keys in FeaturesFlagsData above: the hook camelCases each
 * name, so every entry here must map to a key there. assets-page only needs
 * these, so we request them by name instead of fetching the full flag list.
 */
export const FEATURE_FLAG_NAMES = [
  "advanced_ai_package",
  "dashboard_extension_enable_restricted_companies_assets_page",
  "disable_frontend_tracking",
  "conversation_intelligence_customer_provisioning",
  "conversation_center_disable_sentiments",
  "dashboard_extension_enable_conversations_center_csat",
  "playbook_adherence",
] as const;

export type FeaturesFlagsType = Partial<FeaturesFlagsData>;

export type GetFeaturesFlagsType = FeaturesFlagsType & {
  loading: boolean;
};
